import { z } from "zod"
import type { ApiSuccess } from "@core/types/TApiResponse"

export const SubscriptionSchema = z.object({
  plan: z.string(),
  status: z.string(),
  storage_used: z.number(),
  storage_total: z.number(),
  licenses_consumed: z.number(),
  licenses_total: z.number(),
  expiry_date: z.string(),
  days_remaining: z.number(),
})

export type TSubscription = z.infer<typeof SubscriptionSchema>

export const SubscriptionMemberSchema = z.object({
  plan: z.string(),
  status: z.string(),
  storage_used: z.number(),
  storage_total: z.number(),
  has_license: z.boolean(),
  expiry_date: z.string(),
  days_remaining: z.number(),
})

export type TSubscriptionMember = z.infer<typeof SubscriptionMemberSchema>

export type TSubscriptionResponse = ApiSuccess<TSubscription>
export type TSubscriptionMemberResponse = ApiSuccess<TSubscriptionMember>
